import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'
// import store from '@/store'

async function index () {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
  /*
  const headers = {
    Authorization: 'Bearer ' + store.getters['auth/accessToken']
  }
  */
    const headers = {}
    const req = {
      url: process.env.VUE_APP_URL_API + '/languages?paginate=false',
      method: 'GET',
      headers: headers
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { index }
